import { render, staticRenderFns } from "./PushNotificationsManager.vue?vue&type=template&id=a1423494&scoped=true&"
import script from "./PushNotificationsManager.vue?vue&type=script&lang=js&"
export * from "./PushNotificationsManager.vue?vue&type=script&lang=js&"
import style0 from "./PushNotificationsManager.vue?vue&type=style&index=0&id=a1423494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1423494",
  null
  
)

export default component.exports